import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// 解决路由重复点击报异常问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: () => import("@/components/login.vue")
    },
    {
      //首页
      path: "/index",
      component: () => import("@/views/home/indexNew.vue")
    },
    {
      //智慧果园
      path: "/orchard",
      component: () => import("@/views/orchard/index.vue")
    },
    {
      //智慧乡村
      path: "/mapping3D",
      component: () =>
        import("@/views/businessManager/mapping3D/mapping3D.vue")
    },
    {
      //智慧园区 企业信息可视化 武义 rongQeZhiGu
      path: "/enterprise3D",
      component: () => import("@/views/intelligentGarden/enterprise3D/index.vue")
    },
    {
      //闽锋化学
      path: "/MFHX",
      component: () => import("@/views/intelligentGarden/MFHX/index.vue")
    },
    // {
    //   //
    //   path: "/SC",
    //   component: () => import("@/views/intelligentGarden/SC/index.vue")
    // },
    {
      //丽水高速  
      path: "/highway",
      component: () => import("@/views/highway/index.vue")
    },
    {
      //容祺智谷
      path: "/rongQeZhiGu",
      component: () => import("@/views/rqzg/RQZG.vue")
    },
    {
      //word预览页面
      path: "/previewBox",
      component: () =>
        import("@/views/businessManager/ch4Report/previewBox.vue")
    },
    {
      path: "/menu",
      name: "menu",
      component: () => import("@/components/menu.vue"),
      meta: {
        requireAuth: true
      },
      redirect: "/uavManager",
      children: [
        {
          //测试页面生产环境要删掉
          path: "/test",
          component: () => import("@/views/home/test.vue")
        },
        //飞行平台
        {
          //无人机
          path: "/uavManager",
          component: () =>
            import("@/views/lowFlying/uavManager/uavManager.vue"),
          redirect: "/uavManagerShow",
          children: [
            {
              path: "/uavManagerShow",
              component: () =>
                import("@/views/lowFlying/uavManager/uavManagerShow.vue")
            }
          ]
        },
        {
          //无人机机场
          path: "/AirportManage",
          component: () =>
            import("@/views/lowFlying/AirportManage/AirportManage.vue"),
          redirect: "/AirportManageShow",
          children: [
            {
              path: "/AirportManageShow",
              component: () =>
                import("@/views/lowFlying/AirportManage/AirportManageShow.vue")
            }
          ]
        },
        {
          //航迹航线
          path: "/airWayManager",
          component: () =>
            import("@/views/lowFlying/airWayManager/airWayManager.vue"),
          redirect: "/airWayManagerShow",
          children: [
            {
              path: "/airWayManagerShow",
              component: () =>
                import("@/views/lowFlying/airWayManager/airWayManagerShow.vue")
            }
          ]
        },
        {
          //大疆无人机
          path: "/DJIManger",
          component: () => import("@/views/lowFlying/DJIManager/index.vue"),
          redirect: "/DJIMangerShow",
          children: [
            {
              path: "/DJIMangerShow",
              component: () =>
                import("@/views/lowFlying/DJIManager/DJIManagerShow.vue")
            }
          ]
        },
        //地面传感
        {
          //智慧管网
          path: "/pipelineAI",
          component: () => import("@/views/groundRange/pipelineAI.vue")
        },
        {
          //智能井盖
          path: "/ctwingManager",
          component: () =>
            import("@/views/groundRange/ctwingManager/ctwingManager.vue"),
          redirect: "/ctwingManagerShow",
          children: [
            {
              path: "/ctwingManagerShow",
              component: () =>
                import(
                  "@/views/groundRange/ctwingManager/ctwingManagerShow.vue"
                )
            }
          ]
        },
        //行业应用
        {
          //大气监测（环保模块）
          path: "/atmosphereCheck",
          component: () =>
            import(
              "@/views/businessManager/atmosphereCheck/atmosphereCheck.vue"
            ),
          redirect: "/atmosphereCheckShow",
          children: [
            {
              path: "/atmosphereCheckShow",
              component: () =>
                import(
                  "@/views/businessManager/atmosphereCheck/atmosphereCheckShow.vue"
                )
            }
          ]
        },
        

        {
          //甲烷检测
          path: "/ch4Report",
          component: () =>
            import("@/views/businessManager/ch4Report/ch4Report.vue")
        },

        {
          //监控视频页面
          path: "/Monitor",
          component: () =>
            import("@/views/businessManager/monitoring/monitor.vue"),
          redirect: "/monitorShow",
          children: [
            {
              path: "/monitorShow",
              component: () =>
                import("@/views/businessManager/monitoring/monitorShow.vue")
            }
          ]
        },
        //海域传感
        {
          //船舶排放
          path: "/shipFumes",
          component: () => import("@/views/seaManager/shipFumes.vue")
        },
        //服务支持
        {
          //模型修复前
          path: "/before",
          component: () => import("@/views/support/before.vue")
        },
        {
          //模型修复后
          path: "/after",
          component: () => import("@/views/support/after.vue")
        },

        //系统管理
        {
          //日志管理
          path: "/logManager",
          component: () =>
            import("@/views/systemManager/logManager/logManager.vue")
        },
        {
          //用户管理
          path: "/userList",
          component: () => import("@/views/systemManager/userList/userList.vue")
        },
        {
          //增加用户
          path: "/addUser",
          component: () => import("@/views/systemManager/userList/addUser.vue")
        },
        {
          //修改用户
          path: "/changeUser",
          component: () =>
            import("@/views/systemManager/userList/changeUser.vue")
        },
        {
          //设备分组管理
          path: "/deviceManager",
          component: () =>
            import("@/views/systemManager/deviceManager/deviceManager.vue"),
          redirect: "/deviceManagerShow",
          children: [
            {
              path: "/deviceManagerShow",
              component: () =>
                import(
                  "@/views/systemManager/deviceManager/deviceManagerShow.vue"
                )
            }
          ]
        }
      ]
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js